import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { subscribeOn } from 'rxjs/operators';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { AlertService } from 'src/app/providers/alert.service';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { UserReportType } from 'src/app/shared/constants/user-report-type.enum';
import { MatDialog } from '@angular/material/dialog';
import { PostProfileDetailsComponent } from '../../../shared/components/post-profile-details/post-profile-details.component';
import { BlockUnblockReportedComponent } from '../block-unblock-reported/block-unblock-reported.component';
import { SharedService } from '../../../providers/shared.service';

@Component({
  selector: 'sm-latest-abuse-report',
  templateUrl: './latest-abuse-report.component.html',
  styleUrls: ['./latest-abuse-report.component.scss']
})
export class LatestAbuseReportComponent implements OnInit, OnDestroy {
  reportList: any[] = [];
  profileData: any
  clickEventSubscription: Subscription;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "Report date",
      columnProperty: "creationDate"
    },
    {
      columnName: "reported against",
      columnProperty: "requestToName"
    },
    {
      columnName: "message",
      columnProperty: "message"
    },
    {
      columnName: "reason",
      columnProperty: "categoryType"
    }
  ];
  public loader: boolean = false;
  private _apiSub: Subscription;
  private _apiSubscription: Subscription;


  constructor(private sharedService: SharedService,private _apiService : ApiService, private _datePipe: DatePipe, private _alertService: AlertService, private _dialog: MatDialog) { 
    this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
    this._apiSub = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_USER_REPORT_REQUEST_RESULT){
        console.log(resData);
        resData.result.length = 10
        this.reportList = resData.result ? resData.result : [];
        this.reportList =     this.reportList.sort((dataA:any, dataB:any) =>
        ((+new Date(dataB['creationDate'])) - (+new 
        Date(dataA['creationDate'])))
 
     )
        this.reportList.map(report => {
          report.creationDate = this._datePipe.transform(report.creationDate, 'MMM d, y');
          report.requestTypeInfo = JSON.parse(report.requestTypeInfo);
        });
      }
      if(resData.responseType === SM_CONSTANTS.UPDATE_USER_REQUEST_STATUS_RESULT){
        console.log(resData);
        if(resData.result.errorcode === 0){
          this._apiService.getUserRequest(UserReportType.REPORT_ABUSE, SM_CONSTANTS.GET_USER_REPORT_REQUEST_RESULT);
          this._alertService.onOpenSnackbar(resData.result.message);
        }
      }
     this.loader = false
    });
    this._apiSubscription = new Subscription()
  }

  ngOnInit(): void {
    this.loader= true
    this._apiService.getUserRequest(UserReportType.REPORT_ABUSE, SM_CONSTANTS.GET_USER_REPORT_REQUEST_RESULT);
  }

  onChangeContentStatus(status: 'block' | 'unblock', rowData: any){
    console.log(status, rowData);

    const requestInfo = {
      hash_id: rowData.hash_id,
      requestType: rowData.requestTypeInfo.requestType,
      requestToHash: rowData.requestTypeInfo.hash_id,
      requestStatus: status === 'block' ? 9 : 1
    }
    console.log(requestInfo);
    
    this._apiService.updateUserRequestStatus({requestInfo});
  }

  blockReported(rowvalue: any){

    rowvalue.type = 'block'
    this._dialog.open(BlockUnblockReportedComponent, {
      data: rowvalue,
      
    })
  }

  unblockReported(rowvalue: any){
    rowvalue.type = 'unblock'
    this._dialog.open(BlockUnblockReportedComponent, {
      data: rowvalue,
      
    })
  }

  viewDetails(rowvalue:any){
    console.log(rowvalue);
    this._dialog.open(PostProfileDetailsComponent, {
      data: rowvalue,
      width: '500px',
      panelClass: 'user-profile-dialog'
    });
    
  }


  ngOnDestroy(){
    this._apiSub.unsubscribe();
    this._apiSubscription.unsubscribe();
  }

}
